import React, { useEffect, useState } from "react";
import { api, formatUAH, formatNum } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import PeriodFilter from "@/components/PeriodFilter";
import Referrals from "@/pages/Referrals";

const ROLE_TABS = [
  { key: "doctor", label: "Лікарі" },
  { key: "surgeon", label: "Хірурги" },
  { key: "manager", label: "Менеджери" },
  { key: "paramedic", label: "Фельдшери" },
  { key: "salesperson", label: "Продавці" },
];

function KPITable({ rows, roleKey }) {
  const showConv = roleKey === "doctor" || roleKey === "paramedic" || roleKey === "manager";
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead className="bg-slate-50 text-xs uppercase tracking-wider text-slate-600 sticky top-0 z-10">
          <tr>
            <th className="text-left p-4">ПІБ</th>
            {roleKey === "doctor" && <th className="text-right p-4">Консультації</th>}
            <th className="text-right p-4">Операції</th>
            <th className="text-right p-4">Виручка</th>
            <th className="text-right p-4">Середній чек</th>
            {showConv && <th className="text-right p-4">Конверсія</th>}
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.employee_id} className="border-t border-slate-100">
              <td className="p-4 font-medium">{r.full_name}</td>
              {roleKey === "doctor" && <td className="p-4 text-right tabular-nums">{formatNum(r.consultations)}</td>}
              <td className="p-4 text-right tabular-nums">{formatNum(r.operations)}</td>
              <td className="p-4 text-right tabular-nums font-semibold">{formatUAH(r.revenue)}</td>
              <td className="p-4 text-right tabular-nums">{formatUAH(r.avg_check)}</td>
              {showConv && <td className="p-4 text-right tabular-nums">{r.conversion}%</td>}
            </tr>
          ))}
          {rows.length === 0 && (
            <tr><td colSpan={6} className="p-8 text-center text-slate-400">Немає даних</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default function KPIPage() {
  const [data, setData] = useState({});
  const [period, setPeriod] = useState({});

  useEffect(() => {
    if (period.from === undefined && period.to === undefined) return;
    const params = new URLSearchParams();
    if (period.from) params.set("from_date", period.from);
    if (period.to) params.set("to_date", period.to);
    api.get(`/kpi/by-role?${params}`).then((r) => setData(r.data));
  }, [period]);

  return (
    <div data-testid="kpi-page" className="space-y-6">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <h1 className="heading text-3xl font-bold text-[#0F2027]">KPI працівників</h1>
          <p className="text-sm text-slate-500">Показники ефективності по ролях</p>
        </div>
        <PeriodFilter value={period} onChange={setPeriod} defaultPreset="ytd" />
      </div>

      <Card className="gv-card">
        <CardContent className="p-2">
          <Tabs defaultValue="doctor">
            <TabsList className="bg-slate-100 flex-wrap h-auto">
              {ROLE_TABS.map((t) => (
                <TabsTrigger key={t.key} value={t.key} data-testid={`kpi-tab-${t.key}`}>{t.label}</TabsTrigger>
              ))}
              <TabsTrigger value="referrals" data-testid="kpi-tab-referrals">Направлення</TabsTrigger>
            </TabsList>
            {ROLE_TABS.map((t) => (
              <TabsContent key={t.key} value={t.key} className="mt-3">
                <KPITable rows={data[t.key] || []} roleKey={t.key} />
              </TabsContent>
            ))}
            <TabsContent value="referrals" className="mt-3"><Referrals /></TabsContent>
          </Tabs>
        </CardContent>
      </Card>
    </div>
  );
}
